

import { sanitizeFilename } from "../sanitizeFilename";

export function doubtSolverToPptDocument(result) {
  const slides = [
  {
    kind: "title",
    title: result.pageTitle,
    subtitle: result.curriculumLabel
  },
  {
    kind: "bullets",
    title: "Doubt summary",
    bullets: [result.doubtSummary, ...result.tags]
  },
  ...result.tabs.map((tab) => ({
    kind: "bullets",
    title: tab.title,
    bullets: tab.body.split(/\n+/).filter(Boolean)
  }))];


  return {
    filename: sanitizeFilename(`${result.topicLabel} doubt-solution`, "doubt-solver"),
    title: result.pageTitle,
    subject: result.curriculumLabel,
    author: "Tema Ask iTEMA",
    slides
  };
}